module.exports = __webpack_public_path__ + "img/up.2d30eb9a.webp";